import { CalendarLayoutBrowserConstants } from '../constants';
import { setIsAgendaPaneShown } from '../mutators/agendaPaneStateMutators';
import { setIsLeftNavShown } from '../mutators/leftNavStateMutators';
import { setHasUserSetLeftNav } from '../mutators/setHasUserSetLeftNavMutator';
import { getHasUserSetAgendaPane } from '../selectors/getHasUserSetAgendaPane';
import { getHasUserSetLeftNav } from '../selectors/getHasUserSetLeftNav';
import { shouldShowLeftNavAsOverlay } from '../selectors/shouldShowLeftNavAsOverlay';
import { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';
import { isCanvasViewTypeSelected } from 'owa-calendar-module-store';
import { getSurfaceStore } from 'owa-calendar-surface-surface-store';
import { LayoutChangeSource, onAvailableWidthBucketChanged } from 'owa-layout';
import { orchestrator } from 'satcheljs';

// TODO: VSO #89735 Audit boundary between surface and canvas

// left pane interaction
orchestrator(onAvailableWidthBucketChanged, () => {
    if (shouldShowLeftNavAsOverlay()) {
        setHasUserSetLeftNav(false);
    }
});

// left pane visibility
orchestrator(onAvailableWidthBucketChanged, actionMessage => {
    if (!getHasUserSetLeftNav() && actionMessage.source != LayoutChangeSource.Init) {
        const shouldShowLeftNav = !shouldShowLeftNavAsOverlay() && !isCanvasViewTypeSelected();
        setIsLeftNavShown(shouldShowLeftNav);
    }
});

// agenda pane visibility
orchestrator(onAvailableWidthBucketChanged, actionMessage => {
    const { availableWidthBucket, source } = actionMessage;

    if (
        !getHasUserSetAgendaPane() &&
        source != LayoutChangeSource.Init &&
        source != LayoutChangeSource.DateRangeTypeChange
    ) {
        const { dateRangeType } = getSurfaceStore();
        if (dateRangeType == DateRangeType.Month) {
            const isAgendaPaneShown =
                availableWidthBucket > CalendarLayoutBrowserConstants.shouldShowAgendaPaneAsOverlay;
            setIsAgendaPaneShown(isAgendaPaneShown);
        }
    }
});
